import React from "react";

const ContactUs = () => {
  return (
    <>
      <div className="all-banner contact">
        <div className="container">
          <h1
            data-aos="fade-down"
            data-aos-delay="300"
            data-aos-duration="2000"
          >
            Contact Us
          </h1>
          <div
            className="ban-onfo"
            data-aos="fade-up"
            data-aos-delay="300"
            data-aos-duration="3000"
          >
            Get in touch with us.
          </div>
        </div>
      </div>

      <div className="all-page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="journey-box p-4"
                data-aos="zoom-out"
                data-aos-delay="300"
                data-aos-duration="2000"
              >
                <i className="fa fa-envelope blue-font" aria-hidden="true"></i>
                <div className="head1 mb-2">Email</div>
                <p>
                  <a href="mailto:travel@bluediamondvoyage.com" target="_blank">
                    travel@bluediamondvoyage.com
                  </a>
                  <br />
                  <a
                    href="mailto:ishadoshi@bluediamondvoyage.com"
                    target="_blank"
                  >
                    ishadoshi@bluediamondvoyage.com
                  </a>
                  <br />
                  <a
                    href="mailto:yashdoshi@bluediamondvoyage.com"
                    target="_blank"
                  >
                    yashdoshi@bluediamondvoyage.com
                  </a>
                  <br />
                  <a
                    href="mailto:dollydoshi@bluediamondvoyage.com"
                    target="_blank"
                  >
                    dollydoshi@bluediamondvoyage.com
                  </a>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="journey-box p-4"
                data-aos="zoom-out"
                data-aos-delay="300"
                data-aos-duration="2000"
              >
                <i
                  className="fa fa-map-marker blue-font"
                  aria-hidden="true"
                ></i>
                <div className="head1 mb-2">Address</div>
                <p>
                  Blue Diamond Voyage & Vision Pvt. Ltd. Apran Complex, Near
                  Radhika Jewellers, Kalawad Road, Rajkot - 360001
                  <br/>
                  Gujarat - India
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
              <div
                className="journey-box p-4"
                data-aos="zoom-out"
                data-aos-delay="300"
                data-aos-duration="2000"
              >
                <i className="fa fa-phone blue-font" aria-hidden="true"></i>
                <div className="head1 mb-2">Mobile</div>
                <p className="mb-0">+91 98242 21400</p>
                <p>+91 97148 59797</p>
              </div>
            </div>
          </div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.633267942552!2d70.7814472!3d22.2918777!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959ca2462dea45b%3A0xe934f71fb1f5096a!2sBlue%20Diamond%20Voyage%20%26%20Vision%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1763471808208!5m2!1sen!2sin"
            width="100%"
            height="350"
            style={{ border: "0px" }}
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="container">
          <div className="border-gap"></div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
